const API_URL = process.env.REACT_APP_API_URL_PROD;

const getCheckIfBookPurchased = async (bookId) => {
    const token = localStorage.getItem("access_token_esti");

    if (!token) {
        console.error("Қолданушы тіркелмеген");
        return false;
    }

    try {
        const response = await fetch(`${API_URL}/purchase/check-book-purchase?book_id=${bookId}`, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        return data.purchased;
    } catch (error) {
        console.error("Кітап сатып алынды ма тексеру кезінде қате:", error);
        return false;
    }
};

export default getCheckIfBookPurchased;